import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

// export const useAuth = () => {
//   const context = useContext(AuthContext);

//   if (!context) throw new Error("Auth context must be use inside AuthProvider");

//   return context;
// };

export const useAuth = () => {
  const { user, ...rest } = useAuth0();
  const [userFetched, setUserFetched] = useState({ role: "admin" });

  useEffect(() => {
    if (user) {
      console.log("fetched user: ", user);
      setUserFetched({ ...user, role: "admin" });
    }
  }, [user]);

  return { user: userFetched, ...rest };
};

// export const useAuth = useAuth0;
